import React from 'react';
import Careers from 'templates/careers';

const CareersPage = () => (
  <Careers />
);

export default CareersPage;
